export default function OrganizationInvoicePreview({
    athleteTotal = 0,
    minimumRevenueClauseDifference = 0,
    enableProcessingFee = 0,
    processingFee = 0
}) {

    return (
        <div className="p-4 space-y-2">
            <div className="flex items-center">
                <div className="text-sm text-gray-600 flex-1">Athlete Seats</div>
                <div className="text-sm text-gray-600">${athleteTotal.toFixed(2)}</div>
            </div>
            
            {minimumRevenueClauseDifference > 0 &&
                <div className="flex items-center">
                    <div className="text-sm text-gray-600 flex-1">Minimum Revenue Clause</div>
                    <div className="text-sm text-gray-600">${minimumRevenueClauseDifference.toFixed(2)}</div>
                </div>
            }

            {enableProcessingFee === 1 &&
                <div className="flex items-center">
                    <div className="text-sm text-gray-600 flex-1">Processing Fee</div>
                    <div className="text-sm text-gray-600">${processingFee.toFixed(2)}</div>
                </div>
            }

            <div className="pt-2 flex items-center justify-between">
                <div className="text-xl flex-1">Total</div>
                <div className="text-xl">${(athleteTotal + minimumRevenueClauseDifference + processingFee).toFixed(2)}</div>
            </div>
        </div>
    )
}